import * as React from "react";
import { GridWrapper } from "../../integrations/UoE-Grid/GridWrapper";
import { Logging } from "../../Logging";
import "../../assets/css/AOS2/AOS2_Agent_Access_Page.css";
import { useApi } from "../../Providers/ApiProvider";

export default function AOS2_ADMIN_Agent_Applicant_Numbers() {
  let api = useApi();
  let [data, setData] = React.useState();
  let [YearStartInput, setYearStartInput] = React.useState<number>(2025);
  // let[YearStart, setYearStart] = React.useState<number>(2025);
  let [YearEndInput, setYearEndInput] = React.useState<number>(2025);
  // let[YearEnd, setYearEnd] = React.useState<number>(2025);
  let [valid, setValid] = React.useState<boolean>(false);

  React.useEffect(() => {
    setValid(YearEndInput >= YearStartInput);
  }, [YearStartInput, YearEndInput]);

  return (
    <div className="AOS2_ADMIN_Agent_Applicant_Numbers">
      <h2>Application Per Agent By Year Range</h2>
      <p>
        Enter the required start year and finish year, as long as it is a valid
        range the data will automatically populate.
      </p>
      <p>The year end value will set itself to the same as the start year.</p>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="YearStart">
          Start Year:{" "}
        </label>
        <input
          className="YearStartInput"
          id="YearStartInput"
          type="number"
          min="2006"
          // max="2030"
          //autoComplete="2024"
          value={YearStartInput}
          maxLength={4}
          onChange={(e) => {
            setYearStartInput(e.target.valueAsNumber);
            setYearEndInput(e.target.valueAsNumber);
            console.log(e.target.value);
          }}
        />
      </div>
      <div className="JustASpacer"></div>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="YearEnd">
          End Year:{" "}
        </label>
        <input
          className="YearEndInput"
          id="YearEndInput"
          type="number"
          min="2007"
          // max="2030"
          //autoComplete="2025"
          value={YearEndInput}
          maxLength={4}
          onChange={(e) => {
            setYearEndInput(e.target.valueAsNumber);
            console.log(e.target.value);
          }}
        />
      </div>

      {valid && (
        <>
          <div className="JustASpacer"></div>
          <div className="RequestRow">
            <input
              id="submit"
              type="button"
              value="Search"
              onClick={() => {
                setYearStartInput(YearStartInput);
                setYearEndInput(YearEndInput);
              }}
            />
          </div>

          <div className="JustASpacer"></div>
          <div className="JustASpacer"></div>
          <div className="MainPageData">
            <GridWrapper
              eid={"Agent_Applicant_Numbers"}
              sproc="sputilities.webui.AOSv2_ADMIN_AgentApplicationsByYear"
              params={[
                "@StartYear4",
                YearStartInput.toString(),
                "@EndYear4",
                YearEndInput.toString(),
              ]}
              Callouts={false}
              URLParams={""}
            ></GridWrapper>
          </div>
        </>
      )}
    </div>
  );
}
